'use strict';

var $              = require('jquery');
var DraggableCore  = require('../core/core__draggable.js');
var WindowListItem = require('./window__listitem.js');
var WindowLayer = require('./window__layer.js');
require('velocity-animate');

/**
 * Creates a interactive window object
 *
 * @class
 */

class Window extends DraggableCore {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': ''
            }
        };
    }

    constructor(options) {
        super(options);

        this.template = `
            <div class='editor__window'>
                <div class='editor__window__title js-editor__window__title js-cio-ui-templates__draggable__handle'><%- title %></div>
                <div class='editor__window__content js-editor__window__content'></div>
            </div>
        `;

        super.render();
    }

    /**
     * Add List Content
     * @param {String} leftIcon - icon to show on the left side
     * @param {String} leftIconToggle - icon to show on the left side after left icon has been clicked
     * @param {String} title - a title
     * @param {String} rightIcon - icon to show on the right side (optional)
     * @param {String} rightIconToggle - icon to show on the right side after right icon has been clicked (optional)
     */
    addListItem(leftIcon, leftIconToggle, title, rightIcon, rightIconToggle){
        return new WindowListItem({
            target: $('.js-editor__window__content', this.$el),
            fields: {
                'leftIcon': leftIcon,
                'leftIconToggle': leftIconToggle,
                'title': title,
                'rightIcon': (rightIcon || false),
                'rightIconToggle': (rightIconToggle || false)
            }
        });
    }

    /**
     * Add List Content
     * @param {String} leftIcon - icon to show on the left side
     * @param {String} leftIconToggle - icon to show on the left side after left icon has been clicked
     * @param {String} title - a title
     * @param {String} rightIcon - icon to show on the right side (optional)
     * @param {String} rightIconToggle - icon to show on the right side after right icon has been clicked (optional)
     */
    addLayer(layerColor, title, rightIcon, rightIconToggle){
        return new WindowLayer({
            target: $('.js-editor__window__content', this.$el),
            fields: {
                'layerColor': layerColor,
                'title': title
            }
        });
    }

    /**
     * Visually show the inspector
     * @param {Function} completeCallBack - optional function that gets called on complete
     */
    show(completeCallBack){
        this.$el.css('pointer-events', 'auto');
        this.$el.velocity("stop");
        this.$el.velocity({
            'opacity': 1.0
        }, 220, function () {
            if (typeof completeCallBack === 'function') {
                completeCallBack();
            }
        });
    }

    /**
     * Visually hide the inspector
     */
    hide(){
        var self = this;

        this.$el.velocity("stop");
        this.$el.velocity({
            'opacity': 0
        }, 220, function () {
            self.$el.css('pointer-events', 'none'); // much less expensive call then show/hide
        });
    }

    /**
     * clear the window
     */
    clear(){
        $('.js-editor__window__content',this.$el).html('');
    }
}
module.exports = Window;
